// istanbul ignore file - We can't emulate the ResizeObserver in the mock document.
import React from "react";
import { unstable_batchedUpdates } from "react-dom";

export function useResize(
  observedElement: React.RefObject<HTMLElement> | undefined,
  callback: (entries: ResizeObserverEntry[], observer: ResizeObserver) => void
): void {
  const cachedRect = React.useRef<DOMRect | undefined>(undefined);

  const observer = React.useMemo(() => {
    return new ResizeObserver((entries: ResizeObserverEntry[], observer: ResizeObserver) => {
      const contentRect = entries[0].contentRect;
      const _cachedRect = cachedRect.current;

      if (!_cachedRect || _cachedRect.height !== contentRect.height || _cachedRect.width !== contentRect.width) {
        unstable_batchedUpdates(() => {
          callback(entries, observer);
          cachedRect.current = contentRect;
        });
      }
    });
  }, [callback]);

  React.useEffect(() => {
    if (observedElement && observedElement.current) {
      const _observedElement = observedElement.current;

      observer.observe(_observedElement);
      return () => {
        observer.unobserve(_observedElement);
      };
    }
  }, [callback, observedElement, observer]);
}
